import { baseTheme } from './baseTheme'
import { TTheme } from './themeTypes'

const withFontWeight = (
	key: keyof typeof baseTheme.fontSize,
	fontWeight: string,
): [string, { lineHeight?: string; fontWeight: string }] => {
	const [size, options] = baseTheme.fontSize[key]
	return [size, { ...options, fontWeight }]
}

const fontSize = {
	...baseTheme.fontSize,
	'heading-0': withFontWeight('heading-0', '700'),
	'heading-2': withFontWeight('heading-2', '700'),
	'heading-3': withFontWeight('heading-3', '700'),
	'heading-4': withFontWeight('heading-4', '700'),
	'body-large': withFontWeight('body-large', '400'),
}

export const clone1Theme = {
	...baseTheme,
	extend: {
		...baseTheme.extend,
		spacing: {
			...baseTheme.extend.spacing,
		},
		maxWidth: {
			...baseTheme.extend.maxWidth,
			'desktop-container': 'min(1792px, calc(100% - 64px))',
		},
	},
	colors: {
		...baseTheme.colors,
		black: '#0A0909',
		'dark-grey': '#3F3E3E',
		grey: '#79809A',
		'border-grey': '#D3D8EB',
		'border-grey-50': 'rgba(211,216,235,0.5)',
		'light-grey-70': '#F8F9FC',
		'generator-bg': '#F2F9FF',
		blue: '#5660E8',
		'blue-hover': '#4750D1',
		'light-blue': '#E9F6FF',
		green: '#48BA75',
		'light-green': '#E7F4ED',
		'light-purple': '#F1F2FF',
		'website-bg': '#8EAAFF',
		'plain-text-bg': '#D6DAEB',
		// QR color schemes
		'qr-color-scheme-5': {
			primary: '#B69EDE',
			secondary: '#FFFFFF',
		},
	},
	fontWeight: { ...baseTheme.fontWeight, bold: '700' },
	fontSize,
	borderRadius: {
		...baseTheme.borderRadius,
		'16': '1rem',
		'24': '1.5rem',
		'32': '2rem',
	},
	boxShadow: {
		...baseTheme.boxShadow,
		generator: '0px 4px 14px 0px #36428C29',
	},
	gradient: {
		...baseTheme.gradient,
		'generator-bg': 'linear-gradient(180deg, #FBFDFF 0%, #E9F6FF 100%)',
	},
} as const satisfies TTheme
